export default [
    {
        name: "PaymentBackendList",
        path: "payments/backends",
        component: () => import("./views/PaymentBackendList.vue"),
        meta: {
            title: "Payment Backends",
            perms: "admin",
            icon: "fa-solid fa-plug",
        },
    },
    {
        name: "PaymentBackendCreate",
        path: "payments/backends/create",
        component: () => import("./views/PaymentBackendForm.vue"),
    },
    {
        name: "PaymentBackendUpdate",
        path: "payments/backends/:backend",
        component: () => import("./views/PaymentBackendForm.vue"),
    },
    {
        name: "PaymentOrderList",
        path: "payments/orders",
        component: () => import("./views/PaymentOrderList.vue"),
        meta: {
            title: "Payment Orders",
            perms: "pos_orders",
            icon: "fa-solid fa-credit-card",
        },
    },
    {
        name: "PaymentOrderUpdate",
        path: "payments/orders/:order",
        component: () => import("./views/PaymentOrderForm.vue"),
    },
    {
        name: "PaymentOrderDailyLogList",
        path: "payments/orders/dailylogs",
        component: () => import("./views/PaymentOrderDailyLogList.vue"),
        meta: {
            title: "Payment Order Daily Log",
            perms: "pos_balances",
            icon: "fa-solid fa-calendar-days",
        },
    },
    {
        name: "PaymentOrderDailyLogCreate",
        path: "payments/orders/dailylogs/create",
        component: () => import("./views/PaymentOrderDailyLogForm.vue"),
    },
    {
        name: "PaymentOrderDailyLogUpdate",
        path: "payments/orders/dailylogs/:log",
        component: () => import("./views/PaymentOrderDailyLogForm.vue"),
    },
];
